import { AssessmentButton, Bullets, showToast } from "ui-components";
import "./ApplicantOptOut.scss";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { optOutAssessment } from "../../service/Scope/Scope";
import i18n from "../../i18nConfig";
import { getApplicantAssessmentStatusAndDetailsWithExperience } from "../../service/SubmitAssessment/SubmitAssessment";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import SubmitAssessmentHeader from "../../components/SubmitAssessment/Header/SubmitAssessmentHeader";
import Footer from "../../components/Footer/Footer";

const ApplicantOptOut = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentLanguage = i18n.language;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const applicantId = params.get("applicantId");
  const assessmentId = params.get("assessmentId");
  const companyName = params.get("companyName");
  const [assessmentDetails, setAssessmentDetails] = useState<any>(null);
  const handleOptOut = async () => {
    try {
      const res = await optOutAssessment({ assessmentId, applicantId });
      if (res?.status === 200) {
        showToast(res?.customMessage, "success");
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.error(error);
    }
  };
  // function to get Assessment Details With Experience
  async function getAssessmentDetails() {
    const resAssessDetails =
      await getApplicantAssessmentStatusAndDetailsWithExperience(
        applicantId ?? "",
        assessmentId ?? "",
      );

    if (resAssessDetails?.status === 200) {
      setAssessmentDetails(resAssessDetails?.data);
    } else {
      showToast(resAssessDetails?.customMessage, "error");
    }
  }
  useEffect(() => {
    getAssessmentDetails();
  }, []);
  return (
    <div className="optOutPage">
      <SubmitAssessmentHeader
        hideHeaderWalkthrough={true}
        isMenuHide={true}
        isNavbarVisible={false}
      />
      <div className="container-fluid confirmationSection">
        {assessmentDetails ? (
          applicantId && assessmentId && assessmentDetails?.title ? (
            <div className="applicantOptOut">
              <h2>{assessmentDetails?.title}</h2>
              {assessmentDetails?.assessmentSkills?.length ? (
                <div className="skillsName">
                  {assessmentDetails?.assessmentSkills?.map(
                    (item: any, index: any) => (
                      <div key={index}>
                        <Bullets skillName={item?.skillName} />
                      </div>
                    ),
                  )}
                </div>
              ) : null}
              <div className="otherDetails">
                <div className="otherDetailTexts">
                  <span>{t("GENERAL.COMPANY_NAME")} :</span>
                  <span>{` ${companyName}`}</span>
                </div>
                <div className="otherDetailTexts">
                  <span>{t("SUBMIT_ASSESSMENT.APPROXIMATE_TIME")} :</span>
                  <span>
                    {` ${assessmentDetails.totalTime}`} {t("GENERAL.MINS")}{" "}
                  </span>
                </div>
                <div className="otherDetailTexts">
                  <span>{t("GENERAL.TOTAL_QUESTION")} :</span>
                  <span>{` ${assessmentDetails.totalQuestions}`}</span>
                </div>
              </div>
              <hr />
              <h3>{t("GENERAL.ARE_YOU_SURE_TO_OPT_OUT")}</h3>
              <div className="buttonGroup">
                <AssessmentButton className="optOutBtn" onClick={handleOptOut}>
                  {t("GENERAL.SKIP_ASSESS")}
                </AssessmentButton>
                <AssessmentButton
                  className="stayBtn"
                  onClick={() => navigate("/", { replace: true })}
                >
                  {t("GENERAL.CONTINUE_ASSESS")}
                </AssessmentButton>
              </div>
            </div>
          ) : (
            <Navigate to={`/${currentLanguage}/404-not-found-error`} />
          )
        ) : (
          <div className="loaderSec">
            <Loader />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ApplicantOptOut;
